import { useTokenClaims } from '@app-velocity/request-gateway';

/**
 * sub claim contains user id
 */
export const useUserData = () => {
  const readTokenClaim = useTokenClaims();

  const userEmail = readTokenClaim('email')?.toString().trim();
  const userName = readTokenClaim('name')?.toString().trim();
  const userLogin = readTokenClaim('login')?.toString().trim();
  const userId = readTokenClaim('sub')?.toString().trim();

  return {
    userEmail,
    userName,
    userId,
    userLogin,
  };
};
